/* Brightcart: catalog rendering, Home / Shop / Disclosure views and the language switcher.
   Data comes from brightcart-catalog.js (products) and brightcart-i18n.js (translations).
   Page text comes from the section settings in the Shopify theme editor. */
(function () {
  "use strict";

  const $ = id => document.getElementById(id);
  const CFG = window.BRIGHTCART || {};
  const ASSET = CFG.assetBase || "";
  const SEARCH = "https://www.aliexpress.com/wholesale?SearchText=";
  const REL = 'target="_blank" rel="sponsored nofollow noopener"';
  const VIEWS = ["home", "deals", "shop", "disclosure"];
  const LANGS = { en: "English", he: "עברית", ar: "العربية", ru: "Русский" };

  const esc = s => String(s == null ? "" : s)
    .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");

  /* ---------- catalog ---------- */
  // An image can be a file name in the theme's assets folder, or a full https:// URL.
  const imgUrl = f => (/^(https?:)?\/\/|^data:/.test(f) ? f : ASSET + f);

  const CATS = (window.BRIGHTCART_CATALOG || []).map(c => Object.assign({}, c, {
    items: (c.items || []).map(i => Object.assign({}, i, {
      imgs: i.imgs && i.imgs.length ? i.imgs.map(imgUrl) : null
    }))
  }));

  // Items with an affiliate link use it; items without one open an AliExpress search.
  const href = i => i.url || SEARCH + encodeURIComponent(i.q || i.name);

  const gal = i => `<div class="gal"><img class="main" src="${esc(i.imgs[0])}" alt="${esc(i.name)}" loading="lazy" decoding="async">${
    i.imgs.length > 1
      ? `<div class="thumbs">${i.imgs.map((x, n) =>
          `<button type="button" aria-label="Photo ${n + 1} of ${i.imgs.length}"${n ? "" : ' aria-current="true"'}><img src="${esc(x)}" alt="" loading="lazy" decoding="async"></button>`
        ).join("")}</div>`
      : ""}</div>`;

  let current = "home", queued = false;
  const topicsOf = v => [...document.querySelectorAll("#view-" + v + " .topic")];
  const linksOf = v => [...document.querySelectorAll("#view-" + v + " .side-nav nav a")];
  const viewOf = el => { const v = el.closest(".view"); return v ? v.id.replace("view-", "") : ""; };

  function labels() {
    const d = ($("view-deals") || {}).dataset || {};
    return {
      buy: d.buyLabel || "Shop on AliExpress",
      all: d.allTopics || "All topics",
      empty: d.empty || "New finds are on the way. Check back soon."
    };
  }

  function buildShop() {
    const sn = $("sn"), sections = $("sections"), track = $("track");
    if (!sn || !sections || !track) return false;
    const L = labels();

    sn.innerHTML = CATS.map(c =>
      `<a href="#${esc(c.id)}" data-id="${esc(c.id)}" style="--ac:${esc(c.color)}"><span aria-hidden="true">${esc(c.icon)}</span>${esc(c.name)}<small>${c.items.length || "soon"}</small></a>`
    ).join("");

    sections.innerHTML = CATS.map(c => `
 <section class="topic" id="${esc(c.id)}">
  <header class="th" style="--ac:${esc(c.color)}">
   <span class="badge" aria-hidden="true">${esc(c.icon)}</span>
   <div><h2>${esc(c.name)}</h2><p>${esc(c.blurb)}</p></div>
   <a class="up" href="#deals">${esc(L.all)}</a>
  </header>
  ${c.items.length ? "" : `<p class="soon">${esc(L.empty)}</p>`}
  <div class="grid">${c.items.map(i => `
   <article class="card" data-s="${esc([i.name, i.desc, i.q, c.name].join(" ").toLowerCase())}">
    ${i.imgs ? gal(i) : `<div class="art" style="background:${esc(c.color)}" aria-hidden="true">${esc(i.icon)}</div>`}
    <div class="body"><h3>${esc(i.name)}</h3>${i.desc ? `<p>${esc(i.desc)}</p>` : ""}
     <a class="btn" href="${esc(href(i))}" ${REL}>${esc(L.buy)}</a></div>
   </article>`).join("")}</div>
 </section>`).join("");

    // Moving strip of popular items: every item except those marked hot:0
    const tick = CATS.flatMap(c => c.items).filter(i => i.hot !== 0);
    const chips = tick.map(i => i.imgs
      ? `<a class="pic" href="${esc(href(i))}" ${REL} aria-label="${esc(i.name)}" title="${esc(i.name)}"><img src="${esc(i.imgs[0])}" alt="" loading="lazy"></a>`
      : `<a href="${esc(href(i))}" ${REL}>${esc(i.name)}</a>`).join("");
    track.innerHTML = chips + chips;
    track.style.animationDuration = Math.round(tick.length * 3.4) + "s";

    // topic chips on the home page
    const chipsEl = $("home-topics");
    if (chipsEl) chipsEl.innerHTML = CATS.filter(c => c.items.length).map(c =>
      `<a href="#${esc(c.id)}" style="--ac:${esc(c.color)}"><span aria-hidden="true">${esc(c.icon)}</span>${esc(c.name)}</a>`
    ).join("");

    buildIcons();
    return true;
  }

  // "Our top picks": a photo grid (2 rows of 8) plus four text columns, taken from the catalog
  function buildIcons() {
    const box = $("icons"), grid = $("icons-grid"), cols = $("icons-cols");
    if (!box || !grid || !cols) return;
    const pool = CATS.filter(c => c.items.some(i => i.imgs));
    const seen = new Set();
    const fresh = c => c.items.filter(i => i.imgs && !seen.has(i.name));
    // photo grid: take one item from each topic in turn, so every topic shows up
    const picks = [];
    for (let round = 0; picks.length < 16 && round < 16; round++) {
      pool.forEach(c => {
        if (picks.length >= 16) return;
        const it = fresh(c)[0];
        if (it) { seen.add(it.name); picks.push(it); }
      });
    }
    grid.innerHTML = picks.map(i =>
      `<li><a href="${esc(href(i))}" ${REL}><img src="${esc(i.imgs[0])}" alt="" loading="lazy" decoding="async"><span>${esc(i.name)}</span></a></li>`
    ).join("");
    // text columns: the four biggest topics, each with a few more items
    const big = pool.slice().sort((a, b) => b.items.length - a.items.length).slice(0, 4);
    cols.innerHTML = big.map(c => {
      const more = fresh(c).slice(0, 4);
      return `<nav class="icons-col" aria-label="${esc(c.name)}"><h3><a href="#${esc(c.id)}">${esc(c.name)}</a></h3><ul>${more.map(i =>
        `<li><a href="${esc(href(i))}" ${REL}>${esc(i.name)}</a></li>`).join("")}</ul></nav>`;
    }).join("");
    box.hidden = !picks.length;
  }

  // highlight the topic you're reading in the side menu
  function mark() {
    queued = false;
    if (current !== "deals" && current !== "shop") return;
    const y = window.innerHeight * 0.3;
    const shown = topicsOf(current).filter(t => !t.hidden);
    if (!shown.length) return;
    let cur = shown[0].id;
    shown.forEach(t => { if (t.getBoundingClientRect().top <= y) cur = t.id; });
    linksOf(current).forEach(a => a.classList.toggle("on", a.dataset.id === cur));
  }

  /* ---------- views: Home / Shop / Disclosure ---------- */
  function go(name, keepScroll) {
    if (!VIEWS.includes(name)) name = "home";
    current = name;
    VIEWS.forEach(v => { const el = $("view-" + v); if (el) el.hidden = v !== name; });
    document.querySelectorAll("#nav a").forEach(a =>
      a.dataset.view === name ? a.setAttribute("aria-current", "page") : a.removeAttribute("aria-current"));
    if (!keepScroll) window.scrollTo({ top: 0, behavior: "instant" });
    mark();
    try { history.replaceState(null, "", "#" + name); } catch (_) {}
  }

  function initialRoute() {
    const qp = new URLSearchParams(location.search).get("q");
    if (qp) {
      const inp = $("search-input"); if (inp) inp.value = qp;
      go("deals"); runSearch(qp); return;
    }
    const first = location.hash.slice(1);
    const el = first ? $(first) : null;
    if (el && el.classList.contains("topic")) { go(viewOf(el)); el.scrollIntoView(); }   // a topic link, e.g. #fashion or #shop-fashion
    else go(first);
  }

  /* ---------- search ---------- */
  let query = "";
  const totals = { deals: 0, shop: 0 };
  const tr = k => (T[curLang] || {})[k] || k;

  // remember the original topic counts (English) so they can be restored after a search
  function captureCounts() {
    ["deals", "shop"].forEach(v => linksOf(v).forEach(a => {
      const sm = a.querySelector("small");
      if (sm && a.dataset.count === undefined) a.dataset.count = sm.textContent;
    }));
  }

  function renderStatus() {
    ["deals", "shop"].forEach(v => {
      const box = document.querySelector("#view-" + v + " .search-status");
      if (!box) return;
      box.hidden = !query;
      if (!query) return;
      const n = totals[v];
      const key = n === 0 ? "No products match “{q}”." : n === 1 ? "1 result for “{q}”" : "{n} results for “{q}”";
      box.querySelector("p").textContent = tr(key).replace("{n}", n).replace("{q}", query);
    });
  }

  function runSearch(q) {
    query = String(q || "").trim();
    const terms = query.toLowerCase().split(/\s+/).filter(Boolean);
    const on = terms.length > 0;
    ["deals", "shop"].forEach(v => {
      const vs = $("view-" + v);
      if (!vs) return;
      vs.classList.toggle("searching", on);
      const links = linksOf(v);
      totals[v] = 0;
      topicsOf(v).forEach((t, ti) => {
        let n = 0;
        const topicText = (t.querySelector(".th h2") || {}).textContent || "";   // so "lego" also finds every item in the Lego topic
        t.querySelectorAll(".card").forEach(card => {
          // match the English data and whatever language is currently shown (name + description only)
          const shownText = [...card.querySelectorAll(".body h3, .body p")].map(x => x.textContent).join(" ");
          const hay = ((card.dataset.s || "") + " " + shownText + " " + topicText).toLowerCase();
          const hit = !on || terms.every(w => hay.includes(w));
          card.hidden = !hit;
          if (hit) n++;
        });
        const soon = t.querySelector(".soon");
        if (soon) soon.hidden = on;
        t.hidden = on && n === 0;
        totals[v] += n;
        const a = links[ti];
        if (a) {
          a.hidden = on && n === 0;
          const sm = a.querySelector("small");
          if (sm) sm.textContent = on ? String(n) : (a.dataset.count || "");
        }
      });
    });
    renderStatus();
    if (curLang !== "en") applyLang(curLang);   // re-translate the "soon" labels etc.
    mark();
  }

  function clearSearch() {
    const inp = $("search-input"); if (inp) inp.value = "";
    runSearch("");
  }

  let searchTimer;
  function searchFromInput() {
    const inp = $("search-input");
    if (!inp || !$("view-home")) return;
    if (inp.value.trim() && current !== "deals" && current !== "shop") go("deals");
    runSearch(inp.value);
  }

  /* ---------- currency switcher (display only: checkout stays in the store currency) ---------- */
  const CUR = CFG.currency || {};
  const RATES = { USD: 1 };
  String(CUR.rates || "").split(/[\n,;]+/).forEach(p => {
    const m = p.split("="), c = (m[0] || "").trim().toUpperCase(), v = parseFloat(m[1]);
    if (c && v > 0) RATES[c] = v;
  });
  const BASE = String(CUR.base || "").toUpperCase();
  const CURS = CUR.on === false || !RATES[BASE] ? [] : (() => {
    const l = String(CUR.list || "").split(/[\s,;]+/).map(x => x.toUpperCase()).filter(c => RATES[c]);
    if (!l.includes(BASE)) l.unshift(BASE);
    return l.filter((c, i) => l.indexOf(c) === i);
  })();
  const NUM_LOCALE = { en: "en-US", he: "he-IL", ar: "ar-u-nu-latn", ru: "ru-RU" };
  let curCur = BASE;
  try { const sc = localStorage.getItem("bc-cur"); if (sc && CURS.includes(sc)) curCur = sc; } catch (_) {}

  function fmtMoney(amount, code) {
    try { return new Intl.NumberFormat(NUM_LOCALE[curLang] || "en-US", { style: "currency", currency: code }).format(amount); }
    catch (_) { return amount.toFixed(2) + " " + code; }
  }
  function curSymbol(code) {
    try {
      const part = new Intl.NumberFormat("en-US", { style: "currency", currency: code, currencyDisplay: "narrowSymbol" })
        .formatToParts(0).find(p => p.type === "currency");
      return part ? part.value : code;
    } catch (_) { return code; }
  }

  // Every price in the theme carries data-m (the price in cents of the store currency)
  function applyCurrency() {
    if (!CURS.length) return;
    document.querySelectorAll("[data-m]").forEach(el => {
      if (!el.hasAttribute("data-o")) el.setAttribute("data-o", el.textContent);
      if (curCur === BASE) { el.textContent = el.getAttribute("data-o"); return; }
      const cents = parseFloat(el.getAttribute("data-m"));
      if (!(cents >= 0)) return;
      el.textContent = (el.getAttribute("data-pre") || "") + fmtMoney(cents / 100 / RATES[BASE] * RATES[curCur], curCur);
    });
    const lab = $("cur-cur"); if (lab) lab.textContent = curCur;
    document.querySelectorAll("#lang-menu button[data-cur]").forEach(b => b.setAttribute("aria-current", String(b.dataset.cur === curCur)));
  }

  function setCurrency(code) {
    if (!CURS.includes(code)) return;
    curCur = code;
    try { localStorage.setItem("bc-cur", code); } catch (_) {}
    applyCurrency();
  }

  /* ---------- language switcher ---------- */
  const I18N = window.BRIGHTCART_I18N || { keys: [] };
  const T = {};
  ["he", "ar", "ru"].forEach(l => {
    T[l] = Object.fromEntries((I18N.keys || []).map((k, i) => [k, (I18N[l] || [])[i]]));
  });
  const orig = new WeakMap();
  let curLang = "en";

  function applyLang(lang) {
    const d = T[lang] || {};
    document.documentElement.lang = lang;
    document.documentElement.dir = lang === "he" || lang === "ar" ? "rtl" : "ltr";
    const w = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, {
      acceptNode: n => n.parentElement.closest("script,style,noscript,.lang") ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT
    });
    for (let n; (n = w.nextNode());) {
      if (!orig.has(n)) { const t = n.nodeValue.trim(); if (!t) continue; orig.set(n, t); }
      const en = orig.get(n);
      n.nodeValue = n.nodeValue.replace(/\S(?:[\s\S]*\S)?/, () => d[en] || en);
    }
    ["alt", "title", "aria-label", "placeholder"].forEach(a => document.querySelectorAll("[" + a + "]").forEach(el => {
      const k = "data-en-" + a;
      if (!el.hasAttribute(k)) el.setAttribute(k, el.getAttribute(a));
      const en = el.getAttribute(k);
      el.setAttribute(a, d[en] || en);
    }));
  }

  function savedLang() {
    try { return localStorage.getItem("bc-lang") || "en"; } catch (_) { return "en"; }
  }

  function setLang(lang, save = true) {
    if (!LANGS[lang]) lang = "en";
    curLang = lang;
    applyLang(lang);
    buildLangMenu();
    applyCurrency();
    renderStatus();
    const cur = $("lang-cur"), menu = $("lang-menu");
    if (cur) cur.textContent = LANGS[lang];
    if (menu) menu.querySelectorAll("button").forEach(b => b.setAttribute("aria-current", String(b.dataset.lang === lang)));
    if (save) try { localStorage.setItem("bc-lang", lang); } catch (_) {}
  }

  function buildLangMenu() {
    const menu = $("lang-menu");
    if (!menu) return;
    let html = Object.entries(LANGS).map(([k, v]) =>
      `<li><button type="button" data-lang="${k}" lang="${k}">${v}</button></li>`).join("");
    if (CURS.length) {
      html += `<li class="menu-sep" role="separator"></li><li class="menu-label">${esc(tr("Currency"))}</li>` +
        `<li class="cur-grid">${CURS.map(c =>
          `<button type="button" data-cur="${c}" aria-current="${c === curCur}"><span class="cur-sym">${esc(curSymbol(c))}</span> ${c}</button>`).join("")}</li>` +
        `<li class="menu-note">${esc(tr("Prices are approximate. Checkout is in {c}.").replace("{c}", BASE))}</li>`;
    }
    menu.innerHTML = html;
  }

  function toggleMenu(open) {
    const menu = $("lang-menu"), btn = $("lang-btn");
    if (!menu || !btn) return;
    menu.hidden = !open;
    btn.setAttribute("aria-expanded", String(open));
  }

  /* ---------- events (delegated, so they survive theme-editor re-renders) ---------- */
  document.addEventListener("click", e => {
    // product photo thumbnails
    const tb = e.target.closest(".thumbs button");
    if (tb) {
      const g = tb.closest(".gal");
      g.querySelector(".main").src = tb.dataset.full || tb.querySelector("img").src;
      g.querySelectorAll("button").forEach(x => x.removeAttribute("aria-current"));
      tb.setAttribute("aria-current", "true");
      return;
    }
    // clear search
    if (e.target.closest(".search-status button")) { clearSearch(); return; }
    // language menu
    if (e.target.closest("#lang-btn")) { const m = $("lang-menu"); toggleMenu(m ? m.hidden : false); return; }
    const cb = e.target.closest("#lang-menu button[data-cur]");
    if (cb) { setCurrency(cb.dataset.cur); toggleMenu(false); return; }
    const lb = e.target.closest("#lang-menu button[data-lang]");
    if (lb) { setLang(lb.dataset.lang); toggleMenu(false); return; }
    toggleMenu(false);
    // switching between Home / Shop / Disclosure (only on the home page)
    const a = e.target.closest('a[href^="#"]');
    if (a && $("view-home")) {
      const id = a.getAttribute("href").slice(1);
      if (VIEWS.includes(id)) { e.preventDefault(); go(id); }
      else {
        const el = $(id);
        if (el && el.classList.contains("topic")) {      // topic link: open its view and scroll to the topic
          e.preventDefault();
          if (query) clearSearch();
          const v = viewOf(el);
          if (current !== v) go(v, true);
          el.scrollIntoView();
          try { history.replaceState(null, "", "#" + id); } catch (_) {}
        }
      }
    }
  });
  document.addEventListener("input", e => {
    if (e.target.id !== "search-input") return;
    clearTimeout(searchTimer);
    searchTimer = setTimeout(searchFromInput, 160);
  });
  document.addEventListener("submit", e => {
    if (e.target.id !== "search-form" || !$("view-home")) return;   // on other pages the form just opens the home page
    e.preventDefault();
    clearTimeout(searchTimer);
    searchFromInput();
    const inp = $("search-input"); if (inp) inp.blur();
  });
  document.addEventListener("keydown", e => {
    if (e.key !== "Escape") return;
    toggleMenu(false);
    if (e.target.id === "search-input" && e.target.value) clearSearch();
  });
  addEventListener("scroll", () => { if (!queued) { queued = true; requestAnimationFrame(mark); } }, { passive: true });
  addEventListener("resize", mark);
  addEventListener("hashchange", () => {
    if (!$("view-home")) return;
    const h = location.hash.slice(1);
    if (VIEWS.includes(h)) { if (h !== current) go(h); return; }
    const el = h ? $(h) : null;                       // e.g. back/forward to #shop-fashion
    if (el && el.classList.contains("topic")) {
      const v = viewOf(el);
      if (current !== v) go(v, true);
      el.scrollIntoView();
    }
  });

  /* ---------- sticky header height (used for scroll offsets) ---------- */
  function syncHead() {
    const h = document.querySelector(".site-head");
    if (h) document.documentElement.style.setProperty("--head-h", h.offsetHeight + "px");
  }
  addEventListener("resize", syncHead);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(syncHead);

  /* ---------- start ---------- */
  function init(reload) {
    syncHead();
    buildLangMenu();
    if (CFG.isHome && $("view-home")) {
      buildShop();
      captureCounts();
      if (reload) { go(current, true); const inp = $("search-input"); runSearch(inp ? inp.value : ""); }
      else initialRoute();
    }
    setLang(savedLang(), false);
  }

  init(false);

  // Shopify theme editor: sections are re-rendered when settings change
  document.addEventListener("shopify:section:load", () => init(true));
})();

